import { Buffer } from 'buffer';
import ConversionHelper from './conversionHelper';
import { isOpenStatus } from './statusHelper';

export function encryptString(string) {
    let encrypted = null;
    let buff = new Buffer.from(string);
    encrypted = buff.toString('base64');
    return encrypted;
}

export function decryptString(string) {
    let buff = Buffer.from(string, 'base64');
    let bareString = buff.toString('ascii');
    return bareString;
};

export function fieldSecurity(permissions, status, common, constants, type) {
    if (readOnlyFieldSecurity(permissions)) return false;
    if (type == null || type === common.statusTypes.standard) {
        if ((isOpenStatus(status, constants) || status === constants.statuses.new || status == null || status === constants.statuses.released) &&
            (permissions?.complete === true || permissions?.update === true || permissions?.create === true)) {
            return true;
        } else {
            return false;
        }
    }

    if (type === common.statusTypes.productionOrder) {
        if ((status === constants.productionOrderStatuses.released || status === constants.productionOrderStatuses.new ||
            status === constants.productionOrderStatuses.inserted || isOpenStatus(status, constants, 'productionOrderStatuses')) &&
            (permissions?.complete === true || permissions?.update === true || permissions?.create === true)) {
            return true;
        } else {
            return false;
        }
    }

    if (type === common.statusTypes.batch) {
        if ((status === constants.batchStatuses.inserted || status === constants.batchStatuses.released ||
                status === constants.batchStatuses.growing || status === constants.batchStatuses.harvested) &&
            (permissions?.complete === true || permissions?.update === true || permissions?.create === true)) {
            return true;
        } else {
            return false;
        }
    }

    if (type === common.statusTypes.container) {
        if (status !== constants.containerStatuses.destroyed && (permissions.update === true || permissions.create === true)) {
            return true;
        } else {
            return false;
        }
    }

    if (type === common.statusTypes.lot) {
        if (permissions?.update === true || permissions?.create === true) {
            return true;
        } else {
            return false;
        }
    }

    if (type === common.statusTypes.productionBatch) {
        if ((status === constants.productionBatchStatuses.inserted || status === constants.productionBatchStatuses.released ||
                isOpenStatus(status, constants, 'productionBatchStatuses')) &&
            (permissions?.complete === true || permissions?.update === true || permissions?.create === true)) {
            return true;
        } else {
            return false;
        }
    }

    if (type === common.statusTypes.purchaseOrder) {
        if((status === constants.purchaseOrderStatuses.new || isOpenStatus(status, constants, 'purchaseOrderStatuses')) &&
        (permissions?.complete === true || permissions?.update === true || permissions?.create === true)) {
            return true;
        } else {
            return false;
        }
    }

    if(type === common.statusTypes.ccxPosting){
        if((status === constants.ccxPostingStatuses.new || status === constants.ccxPostingStatuses.inprogress || status === constants.ccxPostingStatuses.posted) && 
        (permissions?.create === true || permissions?.update === true || permissions?.complete === true)){
            return true;
        } else {
            return false;
        }
    }
    return false;
}

export function readOnlyFieldSecurity(permissions) {
    if (permissions?.read === true && permissions?.complete !== true &&
        permissions?.create !== true && permissions?.update !== true &&
        permissions?.review !== true && permissions?.approve !== true) {
        return true;
    } else {
        return false;
    }
}

export function printButtonSecurity(permissions, status, common, constants, type) {
    if (type == null || type === common.statusTypes.standard)
        if (permissions?.print) {
            return true;
        } else {
            return false;
        }
    if (type === common.statusTypes.batch) {
        if ((status !== constants.batchStatuses.inserted &&
                status !== constants.batchStatuses.released) &&
            permissions?.print) {
            return true;
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.productionBatch) {
        if ((status !== constants.productionBatchStatuses.inserted &&
                status !== constants.productionBatchStatuses.released) &&
            permissions?.print) {
            return true;
        } else {
            return false;
        }
    }
}

export function saveButtonSecurity(permissions, status, common, constants, type) {
    if (type == null || type === common.statusTypes.standard) {
        if ((isOpenStatus(status, constants) || status === constants.statuses.new || status === constants.statuses.released) &&
            (permissions?.complete === true || permissions?.update === true ||
                permissions?.create === true)) {
            return true;
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.productionOrder) {
        if ((status === constants.productionOrderStatuses.new || status === constants.productionOrderStatuses.inserted ||
            isOpenStatus(status, constants, 'productionOrderStatuses') || status === constants.productionOrderStatuses.released ||
            status === constants.productionOrderStatuses.planned) &&
            (permissions?.complete === true || permissions?.update === true || permissions?.create === true)) {
            return true;
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.batch) {
        if ((status === constants.batchStatuses.planned || status === constants.batchStatuses.flower ||
                status === constants.batchStatuses.harvested || status === constants.batchStatuses.planned ||
                status === constants.batchStatuses.veg || status === constants.batchStatuses.growing) &&
            (permissions?.complete === true || permissions?.update === true || permissions?.create === true)) {
            return true;
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.container) {
        if (status !== constants.containerStatuses.destroyed && (permissions?.update === true || permissions?.create === true)) {
            return true;
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.lot) {
        if (status !== constants.lotStatuses.destroyed && status !== constants.lotStatuses.finished && (permissions?.update === true || permissions?.create === true)) {
            return true;
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.productionBatch) {
        if ((status === constants.productionBatchStatuses.inserted || status === constants.productionBatchStatuses.released ||
            isOpenStatus(status, constants, 'productionBatchStatuses')) &&
            (permissions?.complete === true || permissions?.update === true || permissions?.create === true)) {
            return true;
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.batchTemplate) {
        if (status === constants.batchTemplateStatuses.inactive &&
            (permissions?.complete === true || permissions?.update === true || permissions?.create === true)) {
            return true;
        } else {
            return false;
        }
    }

    if (type === common.statusTypes.purchaseOrder) {
        if((status === constants.purchaseOrderStatuses.new || isOpenStatus(status, constants, 'purchaseOrderStatuses')) &&
        (permissions?.complete === true || permissions?.update === true || permissions?.create === true)) {
            return true;
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.ccxPosting) {
        if ((status === constants.ccxPostingStatuses.inprogress || status === constants.ccxPostingStatuses.new) &&
            (permissions?.complete === true || permissions?.update === true ||
                permissions?.create === true)) {
            return true;
        } else {
            return false;
        }
    }
    return false;
}

/**
 * Reason codes explaining why a record cannot be unlocked. The values are
 * i18n keys - anything surfacing an unlock reason runs it through t().
 */
export const unlockReasons = {
    noPermission: 'unlockReasonNoPermission',
    lockDate: 'unlockReasonLockDate',
    documentRole: 'unlockReasonDocumentRole',
    parentBatchLocked: 'unlockReasonParentBatchLocked',
    parentOrderLocked: 'unlockReasonParentOrderLocked',
    notLastActivity: 'unlockReasonNotLastActivity',
    outputsConsumed: 'unlockReasonOutputsConsumed',
    outputLotInUse: 'unlockReasonOutputLotInUse',
    containerChanged: 'unlockReasonContainerChanged',
    tenantRestricted: 'unlockReasonTenantRestricted',
    notCompleted: 'unlockReasonNotCompleted',
    unavailable: 'unlockReasonUnavailable'
};

/**
 * Reasons a super user outranks. These are authorization gates - who is allowed
 * to unlock - as opposed to reasons rooted in the state of the data, which the
 * server enforces for every user regardless of rank.
 */
export const superOverridableReasons = [
    unlockReasons.noPermission,
    unlockReasons.documentRole,
    unlockReasons.lockDate
];

/**
 * Reasons a chain unlock can resolve: the record's output is held further down, or its parent
 * batch/order is still locked. A super user gets a Chain unlock button alongside the disabled one.
 */
export const chainableReasons = [
    unlockReasons.outputsConsumed,
    unlockReasons.outputLotInUse,
    unlockReasons.containerChanged,
    unlockReasons.parentBatchLocked,
    unlockReasons.parentOrderLocked,
    unlockReasons.notLastActivity
];

/**
 * The server refuses an unlock when the amount it has to pull back off a
 * container exceeds that container's *available* quantity - not its total. The
 * two payload shapes disagree on the field name: a populated Container document
 * carries both `quantity` and `available`, while the lot-container option lists
 * (`containerService.lotContainers`) already put the available figure in
 * `quantity` and have no `available` at all. Reading `available` first and
 * falling back to `quantity` lands on the number the server will use in both.
 *
 * @returns {?{container: string, available: number, required: number}} null when
 *          the container can cover the amount (or there is nothing to compare)
 */
export function containerShortfall(container, amount) {
    if (container == null) return null;
    const raw = container.available != null ? container.available : container.quantity;
    const available = parseFloat(raw);
    const required = parseFloat(amount);
    if (isNaN(available) || isNaN(required)) return null;
    if (ConversionHelper.round3(required) <= ConversionHelper.round3(available)) return null;
    return {
        container: container.number != null ? container.number : container.label,
        available: ConversionHelper.round3(available),
        required: ConversionHelper.round3(required)
    };
}

/**
 * Stricter sibling of {@link containerShortfall}: the container must still hold
 * *exactly* what this record put into it. Reversing a receipt or a feeding lot
 * is a 1:1 undo, so a container that has drifted in either direction - drawn
 * down downstream, or topped up from somewhere else - can no longer be unwound
 * cleanly, even though the server's own guard only catches the short side.
 *
 * @returns {?{container: string, current: number, recorded: number}} null when
 *          the container still matches
 */
export function containerMismatch(container, amount) {
    if (container == null) return null;
    const raw = container.available != null ? container.available : container.quantity;
    const current = parseFloat(raw);
    const recorded = parseFloat(amount);
    if (isNaN(current) || isNaN(recorded)) return null;
    if (ConversionHelper.round3(current) === ConversionHelper.round3(recorded)) return null;
    return {
        container: container.number != null ? container.number : container.label,
        current: ConversionHelper.round3(current),
        recorded: ConversionHelper.round3(recorded)
    };
}

/**
 * Turns container mismatches into tooltip detail lines.
 */
export function mismatchDetails(mismatches) {
    return mismatches.map(m => ({ key: 'unlockReasonContainerMoved', params: m }));
}

/**
 * Turns container shortfalls into the tooltip detail lines the Unlock button
 * renders under the reason sentence.
 */
export function shortfallDetails(shortfalls) {
    return shortfalls.map(s => ({ key: 'unlockReasonContainerShort', params: s }));
}

/**
 * Statuses that put a record into a locked state, per status type. `complete`
 * is the "revert a completion" case which only needs update rights; the
 * `signed` list is the true signed/reviewed lock which needs unlock rights and
 * respects the financial lock date.
 */
function unlockStatusMap(common, constants, type) {
    if (type == null || type === common?.statusTypes?.standard) {
        return {
            complete: constants?.statuses?.complete,
            signed: [constants?.statuses?.reviewed, constants?.statuses?.signed],
            dateLocked: true
        };
    }
    if (type === common?.statusTypes?.productionOrder) {
        return {
            complete: constants?.productionOrderStatuses?.complete,
            signed: [constants?.productionOrderStatuses?.finished, constants?.productionOrderStatuses?.reviewed],
            dateLocked: true
        };
    }
    if (type === common?.statusTypes?.batch) {
        return {
            complete: constants?.batchStatuses?.complete,
            signed: [constants?.batchStatuses?.signed, constants?.batchStatuses?.reviewed],
            dateLocked: true
        };
    }
    if (type === common?.statusTypes?.productionBatch) {
        return {
            complete: constants?.productionBatchStatuses?.complete,
            signed: [constants?.productionBatchStatuses?.signed, constants?.productionBatchStatuses?.review],
            dateLocked: true
        };
    }
    if (type === common?.statusTypes?.purchaseOrder) {
        return {
            complete: null,
            signed: [constants?.purchaseOrderStatuses?.approved],
            dateLocked: false
        };
    }
    if (type === common?.statusTypes?.ccxPosting) {
        return {
            complete: constants?.ccxPostingStatuses?.complete,
            signed: [constants?.ccxPostingStatuses?.reviewed, constants?.ccxPostingStatuses?.signed],
            dateLocked: true
        };
    }
    return null;
}

function statusMatches(status, target) {
    if (status == null || target == null) return false;
    return status.toString() === target.toString();
}

/**
 * Resolves the state of the Unlock button for a record.
 *
 * `visible` is true once the record has reached a locked status - that is the
 * only time an Unlock button (enabled or not) means anything to the user. When
 * `enabled` is false, `reason` carries the i18n key explaining why, so the
 * screen can render the button disabled with a tooltip instead of hiding it.
 *
 * @returns {{visible: boolean, enabled: boolean, reason: ?string, reasonParams: ?Object}}
 */
export function unlockButtonState(permissions, status, common, constants, type, activityDate, lockDate, isSuper) {
    const state = { visible: false, enabled: false, reason: null, reasonParams: null };
    const map = unlockStatusMap(common, constants, type);
    if (map == null) return state;

    let dateLocked = false;
    if (lockDate != null && activityDate != null && !isSuper) {
        const act = Date.parse(activityDate);
        const locked = Date.parse(lockDate);
        if (!isNaN(act) && !isNaN(locked) && act < locked) {
            dateLocked = true;
        }
    }

    if (statusMatches(status, map.complete)) {
        state.visible = true;
        if (permissions?.update) {
            state.enabled = true;
        } else {
            state.reason = unlockReasons.noPermission;
        }
        return state;
    }

    if (map.signed.some(s => statusMatches(status, s))) {
        state.visible = true;
        if (!permissions?.unlock) {
            state.reason = unlockReasons.noPermission;
        } else if (map.dateLocked && dateLocked) {
            state.reason = unlockReasons.lockDate;
            state.reasonParams = { date: lockDate };
        } else {
            state.enabled = true;
        }
        return state;
    }

    // Record is not in a locked state - there is nothing to unlock, so the
    // button stays hidden rather than showing a disabled control with no point.
    return state;
}

export function completeSigSecurity(permission, signature, status, common, constants, type) {
    if (type == null || type === common.statusTypes.standard || type === common.statusTypes.pestScouting) {
        if (isOpenStatus(status, constants) || status === constants.statuses.complete ||
            status === constants.statuses.reviewed || status === constants.statuses.signed || 
            status === constants.statuses.released || status === constants.statuses.shipped) {
            if (signature === undefined || signature == null) {
                return true;
            } else if (signature !== undefined) {
                return true;
            }
        }
    }

    if (type === common.statusTypes.productionOrder) {
        if (status === constants.productionOrderStatuses.released || isOpenStatus(status, constants, 'productionOrderStatuses') ||
            status === constants.productionOrderStatuses.finished || status === constants.productionOrderStatuses.reviewed ||
            status === constants.productionOrderStatuses.complete) {
            if (signature === undefined) {
                return true;
            } else if (signature !== undefined) {
                return true;
            }
        }
    }

    if (type === common.statusTypes.purchaseOrder) {
        if(status === constants.purchaseOrderStatuses.new || isOpenStatus(status, constants, 'purchaseOrderStatuses')){
            return true;
        } else {
            return false;
        }
    }

    if (type === common.statusTypes.ccxPosting) {
        if (status === constants.ccxPostingStatuses.inprogress || status === constants.ccxPostingStatuses.complete ||
            status === constants.ccxPostingStatuses.reviewed || status === constants.ccxPostingStatuses.signed) {
            if (signature === undefined || signature == null) {
                return true;
            } else if (signature !== undefined) {
                return true;
            }
        }
    }

    return false;
}

export function reviewSigSecurity(permission, signature, status, common, constants, type) {
    if (type == null || type === common.statusTypes.standard) {
        if (status === constants.statuses.complete ||
            status === constants.statuses.reviewed ||
            status === constants.statuses.signed) {
            if ((signature === undefined) || signature !== undefined) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.productionOrder) {
        if (status === constants.productionOrderStatuses.complete || status === constants.productionOrderStatuses.reviewed ||
            status === constants.productionOrderStatuses.finished) {
            if ((signature === undefined) || signature !== undefined) {
                return true
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.batch) {
        if (status === constants.batchStatuses.complete || status === constants.batchStatuses.review ||
            status === constants.batchStatuses.signedOff) {
            return true;
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.productionBatch) {
        if (status === constants.productionBatchStatuses.complete || status === constants.productionBatchStatuses.reviewed ||
            status === constants.productionBatchStatuses.signedOff) {
            return true;
        } else {
            return false;
        }
    }
    if(type === common.statusTypes.pestScouting){
        if(status === constants.statuses.complete){
            return true;
        } else {
            return false;
        }
    }
}

export function approveSigSecurity(permission, signature, status, common, constants, type) {
    if (type == null || type === common.statusTypes.standard) {
        if (status === constants.statuses.reviewed || status === constants.statuses.signed) {
            if ((signature === undefined) || signature !== undefined) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.productionOrder) {
        if (status === constants.productionOrderStatuses.reviewed || status === constants.productionOrderStatuses.finished) {
            if ((signature === undefined) || signature !== undefined) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.batch) {
        if (status === constants.batchStatuses.review || status === constants.batchStatuses.signedOff) {
            return true;
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.productionBatch) {
        if (status === constants.productionBatchStatuses.reviewed || status === constants.productionBatchStatuses.signedOff) {
            return true;
        } else {
            return false;
        }
    }
    return false;
}

export function destructionFieldSecurity(status, permissions, statuses) {
    if(!isOpenStatus(status, { statuses }) && status !== statuses.new){
        return false
    }
    if (permissions?.read === true && permissions?.complete !== true &&
        permissions?.create !== true && permissions?.update !== true &&
        permissions?.review !== true && permissions?.approve !== true &&
        permissions?.unlock !== true) {
        return false;
    }
    return true;
}

export function releaseButtonSecurity(permissions, status, common, constants, type) {
    if (type === common.statusTypes.productionOrder) {
        if (status === constants.productionOrderStatuses.inserted && permissions?.update) {
            return true;
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.batch) {
        if (status === constants.batchStatuses.inserted && permissions?.update) {
            return true;
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.productionBatch) {
        if (status === constants.productionBatchStatuses.inserted && permissions?.update) {
            return true;
        } else {
            return false;
        }
    }
    if(status === constants.statuses.new && permissions?.update){
        return true;
    }
    return false;
}

export function splitButtonSecurity(permissions, status, common, constants, type) {
    if (type == null || type === common.statusTypes.standard)
        return false;
    if (type === common.statusTypes.container) {
        if (status !== constants.containerStatuses.destroyed && permissions?.update) {
            return true;
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.lot) {
        if (status !== constants.lotStatuses.destroyed && status !== constants.lotStatuses.finished && status !== constants.lotStatuses.inprogress && permissions?.update) {
            return true;
        } else {
            return false;
        }
    }
    return false;
}

export function combineButtonSecurity(permissions, status, common, constants, type) {
    if (type == null || type === common.statusTypes.standard)
        return false;
    if (type === common.statusTypes.container) {
        if (status !== constants.containerStatuses.destroyed && permissions.update) {
            return true;
        } else {
            return false;
        }
    }
    if (type === common.statusTypes.lot) {
        if (status !== constants.lotStatuses.destroyed && status !== constants.lotStatuses.finished && status !== constants.lotStatuses.inprogress && permissions?.update) {
            return true;
        } else {
            return false;
        }
    }
    return false;
}

export function moveButtonSecurity(permissions, status, common, constants, type) {
    if (type == null || type === common.statusTypes.standard)
        return false;
    if (type === common.statusTypes.container) {
        if (status !== constants.containerStatuses.destroyed && permissions?.update) {
            return true;
        } else {
            return false;
        }
    }
    return false;
}

export function destroyButtonSecurity(permissions, status, common, constants, type) {
    let result = false;
   if (type === common.statusTypes.batch) {
        if ((status === constants.batchStatuses.inserted || status === constants.batchStatuses.released || status === constants.batchStatuses.growing) && permissions?.delete) {
            result = true;
        } else {
            result = false;
        }
    } else if (type === common.statusTypes.productionBatch) {
        if ((status === constants.productionBatchStatuses.inserted || status === constants.productionBatchStatuses.released ||
                isOpenStatus(status, constants, 'productionBatchStatuses')) && permissions?.delete) {
            result = true
        } else {
            result = false;
        }
    } else if (type === common.statusTypes.productionOrder){
        if((status === constants.productionOrderStatuses.inserted || status === constants.productionOrderStatuses.planned ||
            status === constants.productionOrderStatuses.released || status === constants.productionOrderStatuses.new ||
            isOpenStatus(status, constants, 'productionOrderStatuses')) && permissions?.delete){
            result = true;
        } else {
            result = false;
        }
    } else {
        if(status === constants.statuses.complete || status === constants.statuses.reviewed || status === constants.statuses.signed || status === constants.statuses.deleted){
            result = false;
        } else {
            if(permissions?.delete){
                result = true;
            }
        }
    }
    return result;
}
